import { render, staticRenderFns } from "./describeBlock.vue?vue&type=template&id=2f1cdb1e&scoped=true&"
import script from "./describeBlock.vue?vue&type=script&lang=js&"
export * from "./describeBlock.vue?vue&type=script&lang=js&"
import style0 from "./describeBlock.vue?vue&type=style&index=0&id=2f1cdb1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1cdb1e",
  null
  
)

export default component.exports